import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function Layout() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  return (
    <>
      <ScrollToTop />
      <Header solid={!isHome} />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
